<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Occupant</h4>
      <button
        class="btn-primary btn btn-sm"
        type="button"
        v-on:click="copyClientDetails"
        :disabled="!client"
      >
        Copy Client Details
      </button>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type"
            :options="types"
            v-model="form.type_id"
            label="Occupant Type"
            placeholder="Please Select"
          ></selectlist>

          <inputbox
            v-model="form.first_name"
            name="first_name"
            label="First Name"
          ></inputbox>

          <inputbox
            v-model="form.last_name"
            name="last_name"
            label="Last Name"
          ></inputbox>

          <date-of-birth
            v-model="form.date_of_birth"
            :unlimited="true"
          ></date-of-birth>

          <inputbox
            v-model="form.occupation"
            name="occupation"
            label="Occupation"
          ></inputbox>

          <inputbox
            v-model="form.medical_conditions"
            name="medical_conditions"
            label="Medical Conditions"
          ></inputbox>

          <inputbox
            v-model="form.relation_to_client"
            name="relation_to_client"
            label="Relation to Client"
          ></inputbox>

          <inputbox
            v-model="form.national_insurance"
            name="national_insurance_number"
            label="National Insurance Number"
          ></inputbox>

          <selectlist
            :options="positions"
            v-model="form.position_id"
            label="Seat/Position"
            placeholder="Please Select"
            name="position"
          ></selectlist>

          <toggleswitch
            :labels="true"
            name="requires_glasses"
            label="Requires Glasses?"
            v-model="form.requires_glasses"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="wearing_seatbelt"
            label="Wearing Seatbelt?"
            v-model="form.wearing_seatbelt"
          ></toggleswitch>

          <fieldset>
            <legend>
              Contact Details
              <small class="text-muted"
                >- Enter the occupants contact details here</small
              >
            </legend>

            <inputbox
              v-model="form.telephone"
              name="telephone"
              label="Telephone"
            ></inputbox>

            <inputbox
              v-model="form.email_address"
              name="email"
              label="Email Address"
              type="email"
            ></inputbox>
          </fieldset>
          <fieldset>
            <legend>
              Address Details
              <small class="text-muted"
                >- Enter the occupants address details here</small
              >
            </legend>
            <address-lookup
              :address="address"
              v-on:address="setAddress"
            ></address-lookup>
          </fieldset>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <button v-on:click="addOccupant" type="button" class="btn btn-primary">
        Add New Occupant
      </button>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    types: {
      type: Array,
      required: true
    },

    positions: {
      type: Array,
      required: true
    },

    client: {
      type: Object
    }
  },

  data() {
    return {
      form: new window.Form(
        {
          type_id: null,
          first_name: null,
          last_name: null,
          date_of_birth: null,
          occupation: null,
          medical_conditions: null,
          relation_to_client: null,
          national_insurance: null,
          position_id: null,
          requires_glasses: false,
          wearing_seatbelt: true,
          telephone: null,
          email_address: null,
          address_line_one: null,
          address_line_two: null,
          city: null,
          postcode: null
        },
        false
      )
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    copyClientDetails() {
      if (this.client) {
        this.form.title_id = this.client.title_id;
        this.form.first_name = this.client.first_name;
        this.form.last_name = this.client.last_name;
        this.form.date_of_birth = window.DateManager.format(
          this.client.date_of_birth
        );
        this.form.occupation = this.client.occupation;
        this.form.national_insurance = this.client.national_insurance;
        this.form.telephone = this.client.telephone;
        this.form.email = this.client.email_address;

        this.setAddress(this.client);

        window.toastify.success(
          'Complete',
          "We've copied those details for you."
        );
      }
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    closeModal() {
      this.$emit('close');
    },

    addOccupant() {
      this.form
        .post('/incidents/' + this.incident + '/occupants')
        .then(response => {
          this.$emit('added', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error creating the occupant.'
          );
        });
    }
  }
};
</script>
